import React from 'react';
import PropTypes from 'prop-types';
import RefreshButton from '../RefreshButton';

/**
 * Renders a badge with color based on zone state.
 * 
 * @param {Object} props - The component props.
 * @param {string} props.state - The state of the zone.
 */
const ZoneStateBadge = ({ state }) => {
    //valid is low opacity green
    //invalid is low opacity red
    //unknown is low opacity purple

    const valid = 'rgba(0, 255, 0, 0.2)';
    const invalid = 'rgba(255, 0, 0, 0.2)';
    const unknown = 'rgba(255, 0, 255, 0.2)';

  const colorMap = {
    ZoneClosed: valid,
    ZoneOpen: invalid,
    ZoneBypassed: invalid,
    ZoneAlarmInMemory: invalid,
    ZoneAlarm: invalid,
    ZoneDelinquency: invalid,
    ZoneLowBattery: invalid,
    ZoneFault: invalid,
    TamperPresent: invalid,
    No_TamperPresent: valid,
  };

  return <span style={{ backgroundColor: colorMap[state], padding: "0.5rem" }}>{state}</span>;
};

ZoneStateBadge.propTypes = {
  state: PropTypes.string.isRequired,
};

/**
 * Converts an ISO 8601 timestamp to a readable format.
 * 
 * @param {string} timestamp - The ISO 8601 timestamp.
 * @returns {string} - The readable time string.
 */
const convertToReadableTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString();
  };

/**
 * Renders the zone's timestamps.
 * 
 * @param {Object} props - The component props.
 * @param {string} props.createdAt - The creation timestamp.
 * @param {string} props.updatedAt - The update timestamp.
 */
const ZoneTimestamp = ({ createdAt, updatedAt }) => (
  <div>
    <span>Created: {convertToReadableTime(createdAt)}</span>
    <span>Updated: {convertToReadableTime(updatedAt)}</span>
  </div>
);

ZoneTimestamp.propTypes = {
  createdAt: PropTypes.string.isRequired,
  updatedAt: PropTypes.string.isRequired,
};

/**
 * Main admin card for displaying zone state in a table.
 * 
 * @param {Object} props - The component props.
 * @param {Object} props.state - The state record for the zone.
 */
const ZoneAdminCard = ({ state }) => {
  
    return (
      <div>
      
    <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '2rem' }}>
      <thead>
        <tr style={{ backgroundColor: '#f2f2f2' }}>
          <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Zone Feature</th>
          <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Status</th>
          <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Last Reported At</th>
        </tr>
      </thead>
      <tbody>
        {Object.keys(state).map((key) => {
          const zoneInfo = state[key];
          return (
            <tr key={key}>
              <td style={{ padding: '12px', borderBottom: '1px solid #ddd' }}>{key.replace(/_/g, ' ')}</td>
              <td style={{ padding: '12px', borderBottom: '1px solid #ddd' }}>
                {zoneInfo ? <ZoneStateBadge state={zoneInfo.state} /> : 'N/A'}
              </td>
              <td style={{ padding: '12px', borderBottom: '1px solid #ddd' }}>
                {zoneInfo ? convertToReadableTime(zoneInfo.updatedAt) : 'N/A'}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
      <RefreshButton  />
    </div>
  );
};
  
  ZoneAdminCard.propTypes = {
    state: PropTypes.object.isRequired,
  };
  

export default ZoneAdminCard;
